var helpers = require('./helpers');

module.exports = function FormTabsEngine (config) {

  if (!$.isPlainObject(config))
    return new Error('Parametr config musí být objekt');

  var loadedForms = [];
  var forms = {};
  var formTabsButton = $('.navig-tabs li');

  this.init = loadFormIntoTab;

  formTabsButton.click(handleTabClick);

  for (var key in config) {

    var value = config[key];
    var elemId = `#${key}`;

    if (typeof value === 'string')
      forms[key] = helpers.prepareHtmlLoad(elemId, value);

    if ($.isArray(value) && $.isFunction($(elemId)[value[0]]))
      forms[key] = helpers.prepareWidget(elemId, value[0], value[1] || {});
  }

  function handleTabClick () {

    var formId = $(this).attr('aria-controls');

    loadFormIntoTab(formId);
  }

  function loadFormIntoTab (formId) {

    if (loadedForms.indexOf(formId) < 0 && $.isFunction(forms[formId]))
      forms[formId]();

    loadedForms.push(formId);
  }
};